import { Space } from 'antd';
import { useRouter } from 'next/router';
import { BreadCrumbsViewState } from '../../../../../../layouts/Pages/TicketPagesContentLayout/TicketDetailContentLayout';
import { defineMode } from '../../../../../../utils/forms/formHelpers';
import OrganizationDetailContainer from '../../../../../OrganizationDetailContainer';
import UserDetailContainer from '../../../../../UserDetailContainer';
import { CreateTicketFieldsContainer, EditTicketFieldsContainer } from './TicketFieldsContainer';
import TicketRelationContainer from './TicketRelationContainer';

interface Props {
    viewOption: BreadCrumbsViewState;
    organizationId?: string;
}
export default function TicketInfoLeftSideTabs({ viewOption, organizationId }: Props) {
    const { asPath } = useRouter();
    const mode = defineMode(asPath);
    return (
        <Space size="small" direction="vertical" style={{ padding: '0px', width: '100%' }}>
            <TicketRelationContainer />
            {viewOption === BreadCrumbsViewState.organizationView && (
                <OrganizationDetailContainer organizationId={organizationId} />
            )}
            {viewOption === BreadCrumbsViewState.userView && <UserDetailContainer />}
            {viewOption === BreadCrumbsViewState.ticketView &&
                (mode === 'edit' ? <EditTicketFieldsContainer /> : <CreateTicketFieldsContainer />)}
        </Space>
    );
}
